shadow$provide[534] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Context:{enumerable:true, get:function() {
  return Context;
}}});
var Model = require("./model");
var Overlay = require("./overlay");
var Primitives = require("./primitives");
var Render = require("./render");
var Shaders = require("./shaders");
var Stage = require("./stage");
var Util = require("./util");
var require$three = require("three");
class Context {
  static initClass() {
    this.Namespace = {Model, Overlay, Primitives, Render, Shaders, Stage, Util, DOM:Util.VDOM,};
    this.Version = "2.3.1";
  }
  constructor(renderer, scene = null, camera = null) {
    let canvas;
    this.canvas = canvas = renderer.domElement;
    this.element = null;
    this.shaders = Shaders.Factory(Shaders.Snippets);
    this.renderables = new Render.Factory(Render.Classes, renderer, this.shaders);
    this.overlays = new Overlay.Factory(Overlay.Classes, canvas);
    this.scene = this.renderables.make("scene", {scene});
    this.camera = this.defaultCamera = camera != null ? camera : new require$three.PerspectiveCamera();
    this.attributes = new Model.Attributes(Primitives.Types, this);
    this.primitives = new Primitives.Factory(Primitives.Types, this);
    this.root = this.primitives.make("root");
    this.model = new Model.Model(this.root);
    this.guard = new Model.Guard();
    this.controller = new Stage.Controller(this.model, this.primitives);
    this.animator = new Stage.Animator(this);
    this.api = new Stage.API(this);
    this.speed = 1;
    this.time = {now:+new Date() / 1000, time:0, delta:0, clock:0, step:0,};
  }
  init() {
    this.scene.inject();
    this.overlays.inject();
    return this;
  }
  destroy() {
    this.scene.unject();
    this.overlays.unject();
    return this;
  }
  resize(size) {
    if (size == null) {
      size = {};
    }
    if (size.renderWidth == null) {
      size.renderWidth = size.viewWidth != null ? size.viewWidth : size.viewWidth = 1280;
    }
    if (size.renderHeight == null) {
      size.renderHeight = size.viewHeight != null ? size.viewHeight : size.viewHeight = 720;
    }
    if (size.pixelRatio == null) {
      size.pixelRatio = size.renderWidth / Math.max(0.000001, size.viewWidth);
    }
    if (size.aspect == null) {
      size.aspect = size.viewWidth / Math.max(0.000001, size.viewHeight);
    }
    this.root.controller.resize(size);
    return this;
  }
  frame(time) {
    this.pre(time);
    this.update();
    this.render();
    this.post();
    return this;
  }
  pre(time) {
    if (!time) {
      time = {now:+new Date() / 1000, time:0, delta:0, clock:0, step:0,};
      time.delta = this.time.now != null ? time.now - this.time.now : 0;
      if (time.delta > 1) {
        time.delta = 1 / 60;
      }
      time.step = time.delta * this.speed;
      time.time = this.time.time + time.delta;
      time.clock = this.time.clock + time.step;
    }
    this.time = time;
    if (typeof this.root.controller.pre === "function") {
      this.root.controller.pre();
    }
    return this;
  }
  update() {
    this.animator.update();
    this.attributes.compute();
    this.guard.iterate({step:() => {
      let change = this.attributes.digest();
      return change || (change = this.model.digest());
    }, last() {
      return {attribute:this.attributes.getLastTrigger(), model:this.model.getLastTrigger(),};
    },});
    if (typeof this.root.controller.update === "function") {
      this.root.controller.update();
    }
    this.camera = this.root.controller.getCamera();
    this.speed = this.root.controller.getSpeed();
    return this;
  }
  render() {
    if (typeof this.root.controller.render === "function") {
      this.root.controller.render();
    }
    this.scene.render();
    return this;
  }
  post() {
    if (typeof this.root.controller.post === "function") {
      this.root.controller.post();
    }
    return this;
  }
  setWarmup(n) {
    this.scene.warmup(n);
    return this;
  }
  getPending() {
    return this.scene.pending.length;
  }
}
Context.initClass();

};